import * as yup from 'yup';

export const generateItemAmountsSchema = (cartItems) => {
  return cartItems.reduce((prevItems, currentItem) => {
    return {
      ...prevItems,
      [currentItem.product_id]: yup
        .number()
        .max(currentItem?.productable?.order_limit || 200, 'Cannot buy more than 200 units in one order')
        .min(1, 'Cannot buy less than 1 item')
        .required('')
    }
  }, {});
};

export const generateItemAmountsFormDefaultValues = (cartItems) => {
  return cartItems.reduce((prevItems, currentItem) => {
    return {
      ...prevItems,
      [currentItem.id]: currentItem.quantity
    }
  }, {});
}
